import { Company } from '../Model/Company';
import { storeApi } from './storeApi';

type FileUploadParam = {
  formData: FormData;
};

export const fileApi = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    //TODO not used
    getFileList: builder.query<any, { bankAccount: string }>({
      query: (bankAccount) => {
        return {
          url: `/file?${bankAccount}`,
        };
      },
      providesTags: (result) =>
        result
          ? [...result.map(({ _id }) => ({ type: 'File', _id } as const)), { type: 'File', id: 'LIST' }]
          : [{ type: 'File', id: 'LIST' }],
    }),
    deleteFile: builder.mutation<void, { id: string }>({
      query({ id }) {
        return {
          url: `/file/${id}`,
          method: 'DELETE',
        };
      },
    }),
    getFile: builder.query<any, string>({
      query: (name) => ({
        url: `/file/${name}`,
      }),
    }),
    fileUpload: builder.mutation<any, Partial<Company> & FileUploadParam>({
      query(data) {
        const { _id, formData } = data;
        return {
          url: `/file/${_id}`,
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

export const { useFileUploadMutation, useLazyGetFileQuery, useDeleteFileMutation } = fileApi;
